import Refund from './refund'
import StudentsTnc from './student_tnc/StudentsTnc'
import TeacherTnc from './student_tnc/TeacherTnc'


export default <><StudentsTnc/><TeacherTnc/><Refund /></>